module.exports = __webpack_public_path__ + "img/logotipo2.add1c230.png";